/* eslint-disable */
// Custom add-to-cart override for productAddButtonForm.
// - Browser: attaches to window.themeCustomValidation.addToCartOverride and binds expedite UI.
// - Node/tests: module.exports (pure helpers + addToCartOverride).

(function (root, factory) {
  if (typeof module !== "undefined" && module.exports) {
    module.exports = factory(root);
  } else {
    const api = factory(root);
    root.themeCustomValidation = root.themeCustomValidation || {};
    root.themeCustomValidation.addToCartOverride = api.addToCartOverride;
    root.themeCustomValidation.cleanFormParams = api.cleanFormParams;

    // Bind expedite UI when present; safe to call multiple times.
    if (root.document && root.document.addEventListener) {
      root.document.addEventListener("DOMContentLoaded", function () {
        api.initExpedite(root.document);
      });
      root.document.addEventListener("shopify:section:load", function (evt) {
        api.initExpedite(evt.target);
      });
      root.document.addEventListener("shopify:section:select", function (evt) {
        api.initExpedite(evt.target);
      });
    }
  }
})(typeof window !== "undefined" ? window : globalThis, function (root) {
  // Lightweight HTTP helper that prefers axios if present, otherwise falls back to fetch
  function httpPost(url, payload, headers) {
    const axiosGlobal = root.axios || (root.themeVendor && root.themeVendor.axios);
    if (axiosGlobal) {
      return axiosGlobal.post(url, payload, { headers });
    }
    const isJSON = headers && headers["Content-Type"] === "application/json";
    const body = isJSON ? JSON.stringify(payload) : payload;
    return root
      .fetch(url, {
        method: "POST",
        headers,
        body,
      })
      .then((resp) => {
        if (!resp.ok) {
          const err = new Error(`HTTP ${resp.status}`);
          err.response = resp;
          throw err;
        }
        return resp.json().then((data) => ({ data }));
      });
  }

  function cleanFormParams(formData) {
    const params = new URLSearchParams(formData);
    for (const [key, value] of [...params.entries()]) {
      const trimmed = String(value || "").trim();
      if (trimmed === "") {
        params.delete(key);
        continue;
      }
      if (String(key || "").toLowerCase().includes("seat time")) {
        const normalized = trimmed.replace(/%/g, "").trim();
        let percentValue = parseInt(normalized, 10);
        if (isNaN(percentValue)) {
          params.delete(key);
          continue;
        }
        if (percentValue < 0) percentValue = 0;
        if (percentValue > 100) percentValue = 100;
        params.set(key, `${percentValue}%`);
      }
      if (key.includes("Weight")) {
        const lbsValue = parseFloat(trimmed);
        if (!isNaN(lbsValue)) {
          const kgValue = Math.round(lbsValue * 0.453592);
          params.set(key, `${lbsValue} lbs (${kgValue} kg)`);
        } else {
          params.delete(key);
        }
      }
    }
    return params;
  }

  function buildLineItemProperties(params) {
    const properties = {};
    params.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && match[1]) {
        properties[match[1]] = value;
      }
    });
    return properties;
  }

  function buildMainCartItem(params) {
    const quantityRaw = params.get("quantity");
    const parsedQuantity = parseInt(quantityRaw, 10);
    const item = {
      id: params.get("id"),
      quantity: Number.isNaN(parsedQuantity) ? 1 : Math.max(parsedQuantity, 1),
    };
    const sellingPlan = params.get("selling_plan");
    if (sellingPlan) {
      item.selling_plan = sellingPlan;
    }
    const properties = buildLineItemProperties(params);
    if (Object.keys(properties).length) {
      item.properties = properties;
    }
    return item;
  }

  function getExpediteContext(form) {
    const doc = root.document;
    const formId = form ? form.getAttribute("id") : null;
    const scopedPropertyInput =
      doc && formId && doc.querySelector
        ? doc.querySelector(`[data-wilbers-expedite-prop][form="${formId}"]`)
        : null;
    const containerFromProperty =
      scopedPropertyInput && typeof scopedPropertyInput.closest === "function"
        ? scopedPropertyInput.closest("[data-wilbers-expedite]")
        : null;
    const containerFromForm =
      form && typeof form.querySelector === "function"
        ? form.querySelector("[data-wilbers-expedite]")
        : null;
    const containerFromDoc =
      doc && typeof doc.querySelector === "function"
        ? doc.querySelector("[data-wilbers-expedite]")
        : null;

    const container = containerFromProperty || containerFromForm || containerFromDoc || null;
    return {
      container,
      variantInput: container
        ? container.querySelector("[data-wilbers-expedite-hidden-variant]")
        : null,
      labelInput: container ? container.querySelector("[data-wilbers-expedite-label]") : null,
      choice: container
        ? container.querySelector('[name="wilbers_expedite_choice"]:checked')
        : null,
      propertyInput:
        scopedPropertyInput || (container ? container.querySelector("[data-wilbers-expedite-prop]") : null),
      datasetVariantId: container ? container.getAttribute("data-wilbers-expedite-id") : null,
    };
  }

  function buildExpediteLineItem(expediteVariantId, quantity, container) {
    const resolvedVariantId =
      expediteVariantId ||
      (container ? container.getAttribute("data-wilbers-expedite-id") : null);
    if (!resolvedVariantId) return null;
    const productTitle = container
      ? container.getAttribute("data-wilbers-product-title")
      : "";
    const properties = {};
    if (productTitle) {
      properties["Product"] = productTitle;
    }
    const expediteItem = {
      id: resolvedVariantId,
      quantity: quantity || 1,
    };
    if (Object.keys(properties).length) {
      expediteItem.properties = properties;
    }
    return expediteItem;
  }

  // ----- Expedite UI binding (price fetch + property sync) -----
  function formatMoneySafe(cents) {
    const money = Number(cents || 0);
    const theme = root.theme || {};
    const themeCurrency =
      (root.themeVendor && root.themeVendor.themeCurrency) || root.themeCurrency || null;
    const moneyFormat = theme.moneyFormat || (root.Shopify && root.Shopify.money_format) || "${{amount}}";
    const withCode = !!(theme.settings && theme.settings.currency_code_enable);
    const code = theme.currencyCode || "";

    try {
      if (themeCurrency && typeof themeCurrency.formatMoney === "function") {
        const formatted = themeCurrency.formatMoney(money, moneyFormat);
        return withCode && code ? `${formatted} ${code}` : formatted;
      }
    } catch (e) {
      // fall through
    }

    try {
      if (root.Shopify && typeof root.Shopify.formatMoney === "function") {
        const formatted = root.Shopify.formatMoney(money, moneyFormat);
        return withCode && code ? `${formatted} ${code}` : formatted;
      }
    } catch (e) {
      // fall through
    }

    const amount = (money / 100).toFixed(2);
    const formatted = `$${amount}`;
    return withCode && code ? `${formatted} ${code}` : formatted;
  }

  function bindExpediteContainer(container) {
    if (!container || container.dataset.expediteBound === "true") return;
    container.dataset.expediteBound = "true";

    const priceTarget = container.querySelector("[data-wilbers-expedite-price]");
    const hiddenProperty = container.querySelector("[data-wilbers-expedite-prop]");
    const yesRadio = container.querySelector('[data-wilbers-expedite-radio="yes"]');
    const noRadio = container.querySelector('[data-wilbers-expedite-radio="no"]');
    const expediteVariantId = container.getAttribute("data-wilbers-expedite-id");
    const expediteLabel = container.getAttribute("data-wilbers-expedite-type") || "";

    function updateProperty() {
      if (!hiddenProperty) return;
      const yesChecked = !!(yesRadio && yesRadio.checked);
      hiddenProperty.value = yesChecked ? `Yes - ${expediteLabel}` : "No";
    }

    function loadExpeditePrice() {
      if (!expediteVariantId || !priceTarget || !root.fetch) return;
      return root
        .fetch(`/variants/${expediteVariantId}.js`, { headers: { Accept: "application/json" } })
        .then((resp) => (resp.ok ? resp.json() : null))
        .then((data) => {
          if (!data || typeof data.price !== "number") return;
          priceTarget.textContent = formatMoneySafe(data.price);
        })
        .catch(() => {
          priceTarget.textContent = "";
        });
    }

    if (yesRadio) yesRadio.addEventListener("change", updateProperty);
    if (noRadio) noRadio.addEventListener("change", updateProperty);

    updateProperty();
    return loadExpeditePrice();
  }

  function initExpedite(rootNode) {
    const scope = rootNode || (root.document || null);
    if (!scope || typeof scope.querySelectorAll !== "function") return;
    const containers = scope.querySelectorAll("[data-wilbers-expedite]");
    const tasks = [];
    containers.forEach((c) => {
      const task = bindExpediteContainer(c);
      if (task && typeof task.then === "function") tasks.push(task);
    });
    return Promise.all(tasks);
  }

  function addToCartOverride({ formData, component, url }) {
    const params = cleanFormParams(formData);

    const expediteContext = getExpediteContext(component && component.form);
    const expediteVariantId =
      expediteContext.variantInput && expediteContext.variantInput.value
        ? expediteContext.variantInput.value
        : expediteContext.datasetVariantId;
    const expediteChoiceValue = expediteContext.choice ? expediteContext.choice.value : null;
    const expeditePropValue = (expediteContext.propertyInput ? expediteContext.propertyInput.value : "").trim();
    const expediteSelected = Boolean(
      expediteVariantId &&
        (String(expediteChoiceValue || "").toLowerCase() === "yes" ||
          String(expeditePropValue || "").toLowerCase().startsWith("yes"))
    );

    if (expediteSelected) {
      const mainItem = buildMainCartItem(params);
      const expediteItem = buildExpediteLineItem(expediteVariantId, mainItem.quantity, expediteContext.container);
      const payload = { items: [] };
      if (mainItem) payload.items.push(mainItem);
      if (expediteItem) payload.items.push(expediteItem);
      return httpPost(url, payload, {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
      });
    }

    const formPayload = params.toString();
    return httpPost(url, formPayload, {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/x-www-form-urlencoded",
    });
  }

  return {
    addToCartOverride,
    cleanFormParams,
    initExpedite,
  };
});
